<template>
  <div
    class="m-edition-section-content-info-submenu m-edition-section-content-info-submenu-products"
  >
    <ul>
      <li>
        <router-link
          :class="[$t('mEditionMenu.product.assetsIncluded.children.assets.subedition') === $route.params.subedition
                ? 'submenu-item-active submenu-item-active-products'
                : '']"
          :to="`/${$t('rPaths.product')}/${$route.params.id}/${$t('mEditionMenu.product.assetsIncluded.subject')}/${$t('mEditionMenu.product.assetsIncluded.children.assets.subedition')}`"
        >
        {{ $t('mEditionMenu.product.assetsIncluded.children.assets.subtext') }}

        </router-link>
      </li>
      <li>
        <router-link
          :class="[$t('mEditionMenu.product.assetsIncluded.children.maps.subedition') === $route.params.subedition
                ? 'submenu-item-active submenu-item-active-products'
                : '']"
                    :to="`/${$t('rPaths.product')}/${$route.params.id}/${$t('mEditionMenu.product.assetsIncluded.subject')}/${$t('mEditionMenu.product.assetsIncluded.children.maps.subedition')}`"
        >
          {{ $t('mEditionMenu.product.assetsIncluded.children.maps.subtext') }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductAssetsIncludedSubMenu'
}
</script>
